import React, { Component } from "react";

export default class BaseGrid extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    render() {
        let className = this.props.loading ? "listing loading" : "listing";

        return <ul className={className}>{this.props.children}</ul>;
    }
}
